module.exports = __webpack_public_path__ + "static/media/RescueAtLakeWild.4f9c6180.jpg";